import { render, staticRenderFns } from "./m-chirurgies.html?vue&type=template&id=22d96f5b&scoped=true&external"
import script from "./m-chirurgies.js?vue&type=script&lang=js&external"
export * from "./m-chirurgies.js?vue&type=script&lang=js&external"
import style0 from "./m-chirurgies.scss?vue&type=style&index=0&id=22d96f5b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d96f5b",
  null
  
)

export default component.exports